import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {baseUrl} from "../../../../core/constants/base-url";
import {dailyFeedbackReportsResourceType} from "../configs/daily-feedback-reports-page-config";
import {
  DailyFeedbackReportsAggregationData,
  DailyFeedbackReportsData
} from "../types/daily-feedback-reports-page.types";

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsApiService {
  private http: HttpClient = inject(HttpClient);

  public getDailyFeedbackReportsData(queryParams: RecordsDataRequestQueryParams): Observable<DailyFeedbackReportsData> {
    return this.http.get<DailyFeedbackReportsData>(`${baseUrl}/${dailyFeedbackReportsResourceType.path}/p`, {
      params: queryParams
    });
  }

  public getColumnAggregation(queryParams: RecordsDataRequestQueryParams): Observable<DailyFeedbackReportsAggregationData> {
    return this.http.get<DailyFeedbackReportsAggregationData>(`${baseUrl}/${dailyFeedbackReportsResourceType.path}/columns-aggregation`, {
      params: queryParams
    });
  }
}
